import {
  fetchAllAnnotators,
  fetchAllAnnotatorsFailure,
  fetchAllAnnotatorsRequest,
  fetchAllAnnotatorsSuccess,
  fetchAnnotatorTypes,
  fetchAnnotatorTypesFailure,
  fetchAnnotatorTypesRequest,
  fetchAnnotatorTypesSuccess,
} from 'actions';
import { apiClient as LitLingoClient } from 'client';
import { resourceQueryParamName } from 'constants/resourceQueryNames';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getNavParams, getNavParamsByResource } from 'selectors/nav';
import type { API, RouteParams, SagaReturn } from 'types';

function* fetchAllAnnotatorsSaga(action: ReturnType<typeof fetchAllAnnotators>): SagaReturn {
  const { payload = {} } = action;
  const { name = '' } = payload;
  const { limit = '' } = payload;
  const { searchValue = '' } = payload;

  yield put(fetchAllAnnotatorsRequest());
  const resourceParams = (yield select(
    getNavParamsByResource(resourceQueryParamName.annotator)
  )) as ReturnType<ReturnType<typeof getNavParamsByResource>>;
  const navParams = (yield select(getNavParams)) as ReturnType<typeof getNavParams>;

  const params: RouteParams = {
    ...navParams,
    ...resourceParams,
    ...payload,
    ...{ name: resourceParams.name ? resourceParams.name : name },
    ...{ limit: resourceParams.limit ? resourceParams.limit : limit },
    ...{ broad_search: resourceParams.broad_search ? resourceParams.broad_search : searchValue },
    relationships: [
      'rule_annotators.rule',
      'rule_annotators.rule.campaign_rule_outcomes',
      'rule_annotators.rule.campaign_rule_outcomes.campaign',
      'updated_by',
    ],
    include_pii: 'true',
  };

  if (params.order_desc !== 'true') {
    delete params.order_desc;
  }
  const response = (yield call([LitLingoClient.resources.annotators, 'list'], {
    params,
  })) as API.Response<API.Annotators.List>;
  if (response.error != null) {
    yield put(fetchAllAnnotatorsFailure(response.error));
  } else {
    yield put(fetchAllAnnotatorsSuccess(response.data));
  }
}

function* fetchAnnotatorTypesSaga(): SagaReturn {
  yield put(fetchAnnotatorTypesRequest());
  const response = (yield call([
    LitLingoClient.resources.annotators.extras,
    'types',
  ])) as API.Response<API.Annotators.Types>;
  if (response.error != null) {
    yield put(fetchAnnotatorTypesFailure(response.error));
  } else {
    yield put(fetchAnnotatorTypesSuccess(response.data));
  }
}

function* annotatorSaga(): SagaReturn {
  yield takeLatest(fetchAllAnnotators.toString(), fetchAllAnnotatorsSaga);
  yield takeLatest(fetchAnnotatorTypes.toString(), fetchAnnotatorTypesSaga);
}

export default annotatorSaga;
